import { FilterTypes } from '../constants/initialFilters';
import { PromotionType } from '../types/offers';
import { parseTrimline } from './parseTrimline';

const applyConfirmedFilters = (
  offersList: PromotionType[],
  confirmedFilters: FilterTypes,
  isCaMarket: boolean,
): PromotionType[] => {
  return offersList.filter((offer) => {
    const trimlineMatch =
      !confirmedFilters.trimLine.length ||
      confirmedFilters.trimLine.includes(parseTrimline(offer?.offerModelDetail?.trimline ?? ''));

    return (
      (!isCaMarket || confirmedFilters.vehicleType === offer.offerModelDetail.vehicleType) &&
      (!isCaMarket ||
        !confirmedFilters.offerRegion.length ||
        confirmedFilters.offerRegion.includes(offer?.offerModelDetail?.dag)) &&
      (!confirmedFilters.offerType.length ||
        confirmedFilters.offerType.includes(offer.offerType.toLowerCase())) &&
      (!confirmedFilters.bodyType.length ||
        confirmedFilters.bodyType.includes(offer?.offerModelDetail?.bodyType.toLowerCase())) &&
      (!confirmedFilters.modelFamily.length ||
        confirmedFilters.modelFamily.includes(
          offer.offerModelDetail.modelFamily.replace(/[ -]/g, '').toLowerCase(),
        )) &&
      trimlineMatch &&
      (!confirmedFilters.modelYear.length ||
        confirmedFilters.modelYear.includes(offer?.offerModelDetail?.modelYear.toString()))
    );
  });
};

export default applyConfirmedFilters;
